import { render, staticRenderFns } from "./budgetYearPlanDetail.vue?vue&type=template&id=19f193c4"
import script from "./budgetYearPlanDetail.vue?vue&type=script&lang=js"
export * from "./budgetYearPlanDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19f193c4')) {
      api.createRecord('19f193c4', component.options)
    } else {
      api.reload('19f193c4', component.options)
    }
    module.hot.accept("./budgetYearPlanDetail.vue?vue&type=template&id=19f193c4", function () {
      api.rerender('19f193c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/budget/budgetYearPlanDetail.vue"
export default component.exports